import { render, staticRenderFns } from "./editNickname.vue?vue&type=template&id=a94bb08c&scoped=true&"
import script from "./editNickname.vue?vue&type=script&lang=js&"
export * from "./editNickname.vue?vue&type=script&lang=js&"
import style0 from "./editNickname.vue?vue&type=style&index=0&id=a94bb08c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94bb08c",
  null
  
)

export default component.exports